import { useEffect, useState } from 'react'

import { subscribeGatsbyContentfulRefresh } from '../helpers/refreshGatsbyContentful'

/**
 * True while any `refreshGatsbyContentful()` POST is in flight (including server idle wait).
 */
export const useGatsbyContentfulRefreshStatus = (): boolean => {
  const [isRefreshing, setIsRefreshing] = useState(false)

  useEffect(() => subscribeGatsbyContentfulRefresh(setIsRefreshing), [])

  return isRefreshing
}
